import React from 'react'

import { OrderSyncErrorCell } from './OrderSyncErrorCell'

import { MyRowProps } from '../../types/tableTypes'
import { MoySkladOrderModel } from '../../server/mpsklad_core/Models/Orders/MoySkladOrderModel'

export const MoySkladOrderSyncErrorCell =
  ({row}: MyRowProps<MoySkladOrderModel>) =>
    <OrderSyncErrorCell type={'MoySklad'} row={row}/>